const FilterDaysStyles = {
  selectStyle: {
    // display: 'flex !important',
    // alignItems: 'center !important',

    fontFamily: 'dana-bold',
    color: 'rgba(117, 60, 190, 1)',
  },
  select: {
    background: '#F4F4F4 !important',
    border: '1px solid #FFFFFF',
    boxShadow:
      '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1) !important',
    borderRadius: '12px !important',
    width: '189px !important',
    '& ul': {
      display: 'grid',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& li': {
      width: '170px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#FFFFFF',
      border: '1px solid #EEEEEE',
      boxShadow: '-2px -2px 10px #FFFFFF, 4px 4px 25px rgba(0, 0, 0, 0.08)',
      borderRadius: '12px',
      margin: '6px 0',

      fontWeight: '400',
      fontSize: '12px',
      height: '30px !important',
      minHeight: '30px',
    },
  },
  ItemSelected: {
    background: '#FFFFFF !important',
    border: '1px solid rgba(117, 60, 190, 1) !important',
    transform: 'scale(1) !important',
    color: 'rgba(117, 60, 190, 1) !important',
  },
  numberWeight: {
    display: 'inline',
    fontFamily: 'dana-bold',
    marginLeft: '.1rem',
  },
};
export default FilterDaysStyles;
